import { ArrowRightIcon } from "@phosphor-icons/react/dist/csr/ArrowRight";
import { Button } from "@volca/ui/components/ui/button";
import { Card, CardContent } from "@volca/ui/components/ui/card";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { onboardingTasks } from "./onboarding-tasks";
import type { BusinessOnboarding, IntakeStep, InvoiceSource } from "./types";

const SOURCE_LABELS: Record<InvoiceSource, string> = {
  master_inbox: "One shared inbox",
  individual_mailboxes: "People's own mailboxes",
  vendor_portal: "A vendor website",
  software_portal: "Another software tool",
  paper: "Paper",
  text_message: "Text message",
  fax: "Fax",
  other: "Another way",
};

export const OnboardingInformationList = ({
  state,
  companyName,
  timeZone,
  pending,
  onEdit,
}: {
  state: BusinessOnboarding;
  companyName: string;
  timeZone?: string;
  pending: boolean;
  onEdit: (step: IntakeStep) => void;
}) => {
  const tasks = onboardingTasks(state).filter(
    (task) => task.step !== "onboarding_call",
  );
  return (
    <Card className="w-full gap-0 overflow-hidden py-0">
      <CardContent className="divide-y divide-line p-0">
        {tasks.map((task) => {
          let detail = task.value;
          if (task.step === "invoice_upload")
            detail = state.invoice_samples.length
              ? `${state.invoice_samples.length} ${state.invoice_samples.length === 1 ? "invoice" : "invoices"} added`
              : "No invoices added";
          if (task.step === "company")
            detail = [companyName, timeZone].filter(Boolean).join(" · ");
          if (
            task.step === "invoice_sources" &&
            state.answers.invoice_sources?.length
          )
            detail = state.answers.invoice_sources
              .map((source) => SOURCE_LABELS[source])
              .join(", ");
          if (
            task.step === "forwarding_setup" &&
            state.answers.forwarding_inbox_address
          )
            detail = `${state.answers.forwarding_inbox_address} · ${task.value}`;
          return (
            <Stack
              key={task.step}
              direction="row"
              align="center"
              justify="between"
              gap={4}
              className="w-full px-5 py-4"
            >
              <Stack align="start" gap={1} className="min-w-0">
                <Text variant="label">{task.label}</Text>
                <Text tone="muted" className="break-words">
                  {detail}
                </Text>
              </Stack>
              <Button
                variant="link"
                className="shrink-0 gap-1.5 px-0 text-sm [&_svg]:size-4"
                disabled={pending}
                aria-label={`Edit ${task.label}`}
                onClick={() => onEdit(task.step)}
              >
                Edit
                <ArrowRightIcon aria-hidden="true" />
              </Button>
            </Stack>
          );
        })}
      </CardContent>
    </Card>
  );
};
